import { values, orderBy } from 'lodash';

export function coreConceptVideoCourses(state) {
  return state.coreConceptVideoCourses;
}

export function unitsWithCoreConcepts(state) {
  return state.unitsWithCoreConcepts;
}

export function videoCourses(state) {
  return state.videoCourses;
}

export function videoCourseList(state) {
  return orderBy(values(state.videoCourses), ['created_at'], ['desc']);
}

export function coreConceptVideoCourse(state) {
  return state.coreConceptVideoCourse;
}



// WEBPACK FOOTER //
// ./src/app/video-courses/store/getters.js